<template>
  <div>
    <h1>{{ $t("services.title") }}</h1>
    <calendarServices />
  </div>
</template>
<script>
export default {
  components: {
    calendarServices() {
      return import("@/components/business/services");
    }
  },
  props: {},
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {}
};
</script>
<style lang="sass" scoped></style>
